module.exports = __webpack_public_path__ + "img/H-63-ER-1200-BE.8e0581ac.png";